export default function renderText(value, valueString) {
  if (isNaN(value) && !valueString) return null;
  const finalValue = valueString ? valueString : value;
  const text = document.createElement('p');
  text.classList.add('w5-value-percentage-cell__text');
  text.innerText = finalValue.toString() || '';
  return text;
}